import React from "react";
import {
    Select,
    MenuItem,
    FormControl,
    makeStyles
} from "@material-ui/core";
import Utils from "../../../helpers/Utils";
import {useDispatch, useSelector} from "react-redux";
import {setCallEnvironment} from "../../../reducers/globalDialerV2/globalDialerSlice";

const useStyles = makeStyles((theme) => ({
    formControl: {
        minWidth: '155px !important',
        borderRadius: '8px  !important',
        fontFamily: 'var(--poppins) !important',
        '& .MuiSelect-icon': {
            color: '#ffffff !important',
        },

        '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#3D50FF !important',
            borderWidth: '2px !important'
        },

        '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#3D50FF !important',
            borderWidth: '2px !important'
        },

        '& fieldset.MuiOutlinedInput-notchedOutline': {
            borderColor: '#3D50FF !important',
            borderWidth: '2px !important'
        },

        '& fieldset.MuiOutlinedInput-notchedOutline:hover': {
            borderColor: '#3D50FF !important',
            borderWidth: '2px !important'
        },

        '& fieldset.MuiOutlinedInput-notchedOutline:focus': {
            borderColor: '#3D50FF !important',
            borderWidth: '2px !important'
        },

        '& .MuiSelect-select:focus': {
            backgroundColor: '#3D50FF !important',
        },
    },
    select: {
        fontWeight: '700 !important',
        fontFamily: 'var(--poppins) !important',
        fontSize: '12px !important',
        color: "#ffffff !important",
        padding: "4px 12px !important",
        borderRadius: '8px !important',

        '&.MuiSelect-select': {
            boxSizing: 'content-box !important',
        },

        '&.MuiSelect-selectMenu': {
            height: 'auto !important',
        },

        backgroundColor: '#3D50FF !important',
        '&:focus': {
            backgroundColor: '#3D50FF !important',
            borderRadius: '8px !important',
        },
    },
    menuItem: {
        fontFamily: 'var(--poppins) !important',
        fontWeight: '700 !important',
        fontSize: '12px !important',

        '&.MuiListItem-root': {
            width: "100% !important",
            display: "flex !important",
            position: "relative !important",
            boxSizing: "border-box !important",
            paddingTop: "5px !important",
            paddingBottom: "5px !important",
            justifyContent: "flex-start !important",
            textDecoration: "none !important",
            paddingLeft: "16px !important",
        },

        '&:nth-child(odd)': {
            backgroundColor: '#F2F3F5 !important',
        },
        '&.Mui-selected': {
            backgroundColor: '#ddd !important',
            color: '#161d6c !important',
        },
        '&:hover': {
            backgroundColor: '#ddd !important',
            color: '#161d6c !important',
        },

        '& .nickName': {
            fontSize: "10px",
            marginLeft: "4px",
            color: "#473f3f",
            fontWeight: "700"
        }
    },
    menuPaper: {
        maxHeight: '280px !important',
        overflowY: 'auto !important',
        borderRadius: '4px !important',

        '&::-webkit-scrollbar': {
            width: '6px !important',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#ccc !important',
            borderRadius: '4px !important',
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent !important',
        },
    },
}));

const VirtualNumberSelector = ({ popoverInnerRef2 }) => {
    const dispatch = useDispatch();
    const { virtualNumbers, callEnvironment } = useSelector((state)=>(state.globalDialerV2));
    const classes = useStyles();

    const handleSelectChange = (e) => {
        dispatch(setCallEnvironment({ fromNumber: e.target.value }));
    };

    return (
        <div className="DefaultScreenWrapper">
            <div className="callFromWrapper" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div>Call From: </div>
                <FormControl variant="outlined" className={classes.formControl}>
                    <Select
                        labelId="virtual-number-select-label"
                        value={callEnvironment.fromNumber}
                        onChange={handleSelectChange}
                        classes={{ root: classes.select }}
                        MenuProps={{
                            anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left",
                            },
                            transformOrigin: {
                                vertical: "top",
                                horizontal: "left",
                            },
                            getContentAnchorEl: null,
                            classes: {
                                paper: classes.menuPaper
                            },
                            innerRef: popoverInnerRef2
                        }}
                        renderValue={(selected) => {
                            const item = virtualNumbers.find((opt) => opt.virtual_number === selected);
                            return item ? Utils.formatNumber(item.label) : "";
                        }}
                    >
                        {virtualNumbers.map((virtualNumber) => (
                            <MenuItem
                                key={virtualNumber.virtual_number}
                                value={virtualNumber.virtual_number}
                                className={`${classes.menuItem} dropdownhelper-menuitem-class`}
                            >
                                {Utils.formatNumber(virtualNumber.label)}
                                {virtualNumber.nickname ? <span className={"nickName"}>({virtualNumber.nickname})</span> : ""}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
        </div>
    );
};

export default VirtualNumberSelector;